<template>
    <div id="bottom-menu">
        <div id="inferior-menu" class="w-100">
            <div class="d-flex row col-12 col-md-12 w-100">
              <div id="imagenDeFondo_div" class="d-none d-sm-none d-md-none d-lg-flex col-lg-1 col-xl-1 contenedor separador">
                <!--<img class="vertical-center" src="../../../assets/logo-pj-transparente-blanco.png" />-->
                <img class="vertical-center" src="../../../assets/paginaoficial/Logotipo_Negativo_Vertical.png" />
              </div>
                <div id="poderJudicial_div" class="d-none d-sm-none d-md-none d-lg-flex col-lg-6 col-xl-6 contenedor">
                    <ul class="vertical-center">
                        <li><a target="blank" href="https://goo.gl/maps/L27vDRLym1cNcNVm6"><i class="fas fa-building"></i>&nbsp;Héroe de Nacozari esq, Av Lic. Adolfo López Mateos Ote S/N, San Luis, 20250 Aguascalientes, Ags.</a></li>
                        <li><i class="fas fa-phone"></i>&nbsp;449 910 3550</li>
                        <li><i class="fas fa-copyright"></i>&nbsp;{{anio}} - Todos los derechos reservados.</li>
                        <li><i class="fas fa-code-branch"></i>&nbsp;&nbsp;&nbsp;Versión del portal: 1.1.6</li>
                    </ul>
                </div>
                <div id="informacionDeInteres_div" v-for="menu in menus" v-bind:key="menu.MenuId" class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 contenedor">
                    <p class="enMayusculas">{{menu.Titulo}}</p>
                    <div class="row col-md-12 col-12 h-50">
                        <ul class="disminuir-fuente row h-100">
                            <li class="col-6 col-md-6" v-for="submenu in menu.Submenus" v-bind:key="submenu.SubmenuId">
                                <a v-if="!submenu.SeMuestraEnVisor" :href="submenu.RutaParaAccesar" target="blank">{{submenu.Titulo}}</a>
                                <a v-if="submenu.SeMuestraEnVisor" @click="AbreElVisor(submenu.RutaParaAccesar)" target="blank">{{submenu.Titulo}}</a>
                                
                                
                                </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import enumeraciones from "@/../static/js/enumeraciones";
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
import api from "@/../static/js/api";
import axios from "axios";

export default {
    data() {
        return {
            enumeraciones,
            enumeraciones_sicpo,
            PAGINA_DE_INICIO: 1,
            TIPO_POSICION: 2,
            menus: [],
            anio: "",
            nombreDeVariableDelComponente: "cargoMenuInferior"
        };
    },
    methods: {
         AbreElVisor: function(vinculo) {  
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
        CargaElMenu: function() {
            let parametros = {
                EsPrueba: this.enumeraciones.EsPrueba, 
                PaginaDeInicioId: this.PAGINA_DE_INICIO, 
                TipoPosicionId: this.TIPO_POSICION
            }

            axios
                .post(api.conexion + api.SICPO.sistema.paginaweb.paginaoficial.ObtenLosMenusYSubmenusDeLaPaginaOficial, parametros)
                .then(respuesta => {
                if (respuesta.data.SiHayError) {
                    console.error(respuesta.data);
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
                } else {
                    this.menus = respuesta.data.Menus;
                    this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Cargado);
                }
            })
            .catch(excepcion => {
                console.error(excepcion);
                this.YaTermineDeCargar(this.enumeraciones_sicpo.EstadosDeCarga.Error);
            });
        },
        YaTermineDeCargar: function(estatus) {
            this.$emit("marcaLaCargaYVerifica", this.nombreDeVariableDelComponente, estatus);
        }
    }, 
    mounted() {
      this.CargaElMenu();

      this.anio = moment().format('YYYY');
    }
}
</script>

<style scoped>
.bottom-menu {
    z-index: 2 !important;
} 

.enMayusculas {
  text-transform: uppercase;
  color: #FFFFFF;
}

  #inferior-menu {
    display: flex;
    align-items: center;
    height: auto;
    font-size: 18px;
    /*background-color: #007573;*/
    background-color: rgb(0,117,115);
    /*background-color: rgb(34,34,34);*/
    /* z-index: 10 !important; */
    position: relative;
  }

/* #inferior-menu div{
    height: 200px; 
} */

a {
    color: #FFFFFF;
    margin-right: 0px;
}

a:hover {
  color: #be9a5e;
}

.separador {
    border-right: 2px solid white;
}

.contenedor {
  position: relative;
}

.vertical-center {
  margin: 0;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  position: absolute;
  color: #FFFFFF;
}

img {
    width: 75%;
}

.disminuir-fuente {
    font-size: .7rem;
    color: #FFFFFF;
}

p {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/MenuInferior.vue